import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({
  showSpinner: false,
  speed: 400,
  trickleSpeed: 200,
  easing: "ease",
});

const ProgressBar = ({ onLoadingChange }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    onLoadingChange(true);
    NProgress.start();

    const timer = setTimeout(() => {
      NProgress.done();
      setIsLoading(false);
      onLoadingChange(false);
    }, 600); // Adjust duration here

    return () => {
      clearTimeout(timer);
      NProgress.done();
    };
  }, [location, onLoadingChange]);

  return null;
};

export default ProgressBar;
